// Contact addresses are taken verbatim from the approved HTML prototypes.
export const links = {
  telegramHelp:
    'https://t.me/twometerguide?text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5%2C%20%D1%85%D0%BE%D1%87%D1%83%20%D1%81%D0%BE%D0%B1%D1%80%D0%B0%D1%82%D1%8C%20%D0%BF%D0%BE%D0%B5%D0%B7%D0%B4%D0%BA%D1%83%20%D0%B2%E2%80%A6',
  vk: 'https://vk.com/2meterguide',
  max: '',
  phone: 'tel:+79052407010',
  phoneDisplay: '+7 (905) 240-70-10',
  telegram: 'https://t.me/twometerguide',
  email: 'mailto:dialog@dvuhmetrovigid.ru',
} as const;
